/**
 * Created by jv on 25/07/2017.
 */
let hasLogged = false;

/**
  Examples:

  logger.info("Hi");
  logger.warn("Warning");
  logger.error("Error");
  logger.cssLog("Whole log is logged as %s", "success", logger.successCss);
  logger.cssLog("Logging with %cwarning colors%c", logger.warningCss);
  logger.cssLog("Logging some %s, with %c%s css%c and some number: %d", "variable", "custom", 23, logger.errorCss);
 */
export default (() =>
{
  let Logger = {};

  const isDevEnvironment = process.env.NODE_ENV === "development";
  const loggingEnabled = isDevEnvironment || localStorage.getItem("__ENABLE_LOGGING__") === "true";

  function isDebug()
  {
    return loggingEnabled || window.__ENABLE_LOGGING__;
  }

  function firstLogCheck()
  {
    if(!hasLogged)
    {
      console.log("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
      hasLogged = true;
    }
  }

  function logWrapper(logFn)
  {
    if(isDebug())
    {
      firstLogCheck();
      logFn();
    }
  }

  Logger.trace = (...args) =>
  {
    logWrapper(() => console.trace.apply(null, args));
  };

  Logger.debug = (...args) =>
  {
    logWrapper(() => console.debug.apply(null, args));
  };

  Logger.log = (...args) =>
  {
    logWrapper(() => console.log.apply(null, args));
  };

  Logger.info = (...args) =>
  {
    logWrapper(() => console.info.apply(null, args));
  };

  Logger.cssLog = (...args) =>
  {
    logWrapper(() => {
      args = Logger.cssify.apply(null, args);
      console.log.apply(null, args)
    });
  };

  Logger.warn = (...args) =>
  {
    logWrapper(() => console.warn.apply(null, args));
  };

  Logger.error = (...args) =>
  {
    logWrapper(() => console.error.apply(null, args));
  };

  Logger.cssify = (...args) =>
  {
    if(args.length > 1)
    {
      const css = args[args.length - 1];
      args.splice(args.length - 1, 1);

      let cssString = "";

      for(let key in css)
      {
        if(Object.prototype.hasOwnProperty.call(css, key))
        {
          cssString += (key + ": " + css[key] + ";");
        }
      }

      if(typeof args[0] === "string")
      {
        if((args[0].match(/%c/g) || []).length === 0)
        {
          // Css applies to the whole text so just insert the css at the second (first is the text) and last place
          args[0] = "%c" + args[0] + "%c";

          args.splice(1, 0, cssString);
          //Resets the css
          args.push("");
        }
        else if(args.length === 1)
        {
          //If there's only text with no arguments, same as before, insert css at second and last place
          args.push(cssString);
          //Resets the css
          args.push("");
        }
        else
        {
          // Determine where the css arguments need to go in the array
          /*
             %s - String.
             %d - Number (integer or floating point value).
             %i - Integer.
             %f - Floating point value.
             %j - JSON. Replaced with the string '[Circular]' if the argument contains circular references.
             %o - JavaScript Object
           */

          // position BEFORE the first %c
          const startPos = args[0].indexOf("%c");
          // position AFTER the last %c
          const endPos = args[0].lastIndexOf("%c") + 2;

          if(startPos !== -1 && endPos !== -1 && startPos !== endPos)
          {
            const leftSubString = args[0].substring(0, startPos);
            const rightSubString = args[0].substr(endPos);
            // Find all format occurrences
            const firstInsert = (leftSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
            const secondInsert = (rightSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;

            // Account for the text that's in the first position
            args.splice(firstInsert + 1, 0, cssString);
            //Resets the css
            args.splice(args.length - secondInsert, 0, "");
          }
        }
      }

      return args;
    }
  };

  // http://www.flatuicolorpicker.com/
  /*
    SUMMER SKY
    1E8BC3
    30, 139, 195
   */
  Logger.infoCss = {
    "background-color": "#1E8BC3",
    "color": "#ffffff"
  };

  /*
    EUCALYPTUS
    26A65B
    38, 166, 91
   */
  Logger.successCss = {
    "background-color": "#26A65B",
    "color": "#ffffff"
  };

  /*
    SANDSTORM
    F9BF3B
    249, 191, 59
   */
  Logger.warningCss = {
    "background-color": "#F9BF3B",
    "color": "#000000"
  };

  /*
    FLAMINGO
    EF4836
    239, 72, 54
   */
  Logger.errorCss = {
    "background-color": "#EF4836",
    "color": "#ffffff"
  };

  return Logger;
})();